import { useEffect, useState } from 'react';
import { ProductInfo } from '../AdjustRelateKnowledge/ProductInfo';
import { ModifyOnChatSidebar } from './Sidebar';
import { SupplementKnowledgeDetailResponse } from 'services/api/supplementKnowledge';

interface Props {
  conversation: Conversation.Conversation;
  supplementKnowledgeDetail: SupplementKnowledgeDetailResponse;
  onDone?: () => void;
  onDelayRefresh?: () => void;
  onRefresh?: () => void;
}

export const CustomerSourceContent = (props: Props) => {
  const { conversation, supplementKnowledgeDetail, onDone, onDelayRefresh, onRefresh } = props;
  const [defaultApplyType, setDefaultApplyType] = useState<'link' | 'sku' | undefined>(undefined);
  const [skuSelected, setSkuSelected] = useState<string[]>([]);

  const { itemIdentifier, supplementalKnowledgeValue } = supplementKnowledgeDetail;

  useEffect(() => {
    if (itemIdentifier && supplementalKnowledgeValue) {
      const { skus } = itemIdentifier;
      const { skuIds } = supplementalKnowledgeValue;
      setSkuSelected(skuIds);
      setDefaultApplyType(skuIds.length === 0 || skuIds.length === skus?.length ? 'link' : 'sku');
    }
  }, [itemIdentifier, supplementalKnowledgeValue]);

  return (
    <div className="relative w-full h-full flex flex-col gap-2">
      {itemIdentifier && (
        <ProductInfo
          defaultApplyType={defaultApplyType}
          spuId={itemIdentifier.spuId}
          title={itemIdentifier.title}
          price={itemIdentifier.price}
          unit={itemIdentifier.unit}
          imageUrl={itemIdentifier.imageUrl}
          skuInfo={itemIdentifier.skus}
          skuSelected={skuSelected}
          onSKUChange={setSkuSelected}
          onDelayRefresh={onDelayRefresh}
          onRefresh={onRefresh}
        />
      )}
      <ModifyOnChatSidebar
        autoLocate={false}
        conversation={conversation}
        dataSource={supplementKnowledgeDetail}
        onActionDone={onDone}
      />
    </div>
  );
};
